import { components } from 'type/ReportServiceSchema';

export type ImpactOnEngagementLabelDto = components['schemas']['ImpactOnEngagementLabel'];

export enum ImpactOnEngagementLabelModel {
  Low = 'Low',
  Medium = 'Medium',
  High = 'High',
  VeryHigh = 'Very High',
}

export const mapImpactOnEngagementLabelDtoToModel = (
  dto: ImpactOnEngagementLabelDto
): ImpactOnEngagementLabelModel => {
  switch (dto) {
    case 'Very High':
      return ImpactOnEngagementLabelModel.VeryHigh;
    case 'High':
      return ImpactOnEngagementLabelModel.High;
    case 'Medium':
      return ImpactOnEngagementLabelModel.Medium;
    case 'Low':
      return ImpactOnEngagementLabelModel.Low;
    default:
      throw new Error(`Unknown ImpactOnEngagementLabel: ${dto}`);
  }
};
